import {Base, model, belongsTo, endpoint} from '@scoutgg/ftw/source/lib/model'
import positions from '../../helpers/positions'

@model('PlayerSource')
@endpoint('player-sources', {root: '/api'})
@belongsTo('player')
@belongsTo('overrideTeam', 'Team')
@belongsTo('teamSource')
@belongsTo('seasonSource')
export class PlayerSource extends Base {
  get name() {
    return [this.lastName, this.firstName].join(', ')
  }
  get pos() {
    return positions[this.position] ||
      (this.position || '?').slice(0, 3).toUpperCase()
  }
  get team() {
    return this.teamName || 'N/A'
  }
  get teamName() {
    if(!this.teamSource) return ''
    if(!this.teamSource.team) return ''
    return this.teamSource.team.name || ''
  }
}
